<div> <button mat-icon-button [mat-dialog-close]="{cancel: true}" class="close-dialog">
  <mat-icon>close</mat-icon>
</button>
<h2 mat-dialog-title> Issue Updates </h2>
<div class="mat-dialog-title-content">
  <div class="scroll-container">
    <div>
      <label>Title: </label> {{outage.title}}
    </div>
    <div>
      <label>Description: </label> {{outage.description}}
    </div>
    <hr/>
    @for (update of updates; track update) {
      <div>
        <p>
          <span [ngClass]="getClass(update.status)">{{update.status}}</span>
          <span> - {{update.comment}}</span> <br>
          <span style="font-size: 12px;"><i>{{update.createTime | date: 'short'}} by {{update.createdBy}}</i></span>
        </p>
        <hr/>
      </div>
    }
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close> Close </button>
</div>
</div>